import { render, staticRenderFns } from "./StoreLocatorFaqManageDialog.vue?vue&type=template&id=4c2f9bc8&scoped=true&"
import script from "./StoreLocatorFaqManageDialog.vue?vue&type=script&lang=js&"
export * from "./StoreLocatorFaqManageDialog.vue?vue&type=script&lang=js&"
import style0 from "./StoreLocatorFaqManageDialog.vue?vue&type=style&index=0&id=4c2f9bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2f9bc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VTextarea})
